var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.name,{tag:"component",attrs:{"params":_vm.params,"context":_vm.context},on:{"submit-params":_vm.submitParams,"immediate-submit-params":function($event){return _vm.immediateSubmitParams()},"new-expression":_vm.nextExpression}})
}
var staticRenderFns = []

export { render, staticRenderFns }